/**
 * UI Colors: Colors used for type and icons. Especially below 18px
 */


/**
 * Brand Colors: Colors used for backgrounds. They can also be used for large text and icons.
 */
export const bombasBlue = '#2E4366';
export const bombasSeafoam = '#31AAB7';
export const bombasCream = '#FBF6EE';
export const bombasYellow = '#FDF185';
export const bombasRed = '#E0563E';
export const bombasGreen = '#098750';

export const transparent = 'transparent';

export const primaryButtonHover = '#28508F';

// Black
export const ui_black = '#030302';
/**
* @deprecated use ui_black instead
*/
export const black = ui_black;

// Blue
/**
* @deprecated use bombasBlue instead
*/
export const blue = bombasBlue;
/**
* @deprecated use bombasBlue instead
*/
export const blue20 = bombasBlue;
export const ui_focus = '#0465DC';

// Gray

export const ui_grey20 = '#F3F3F2';
export const ui_grey40 = '#DCDBD9';
export const ui_grey60 = '#585653';
export const ui_grey80 = '#333130';
/**
* @deprecated use ui_grey20 instead
*/
export const grey20 = ui_grey20;
/**
* @deprecated use ui_grey40 instead
*/
export const grey40 = ui_grey40;
/**
* @deprecated use ui_grey60 instead
*/
export const grey60 = ui_grey60;
/**
* @deprecated use ui_grey80 instead
*/
export const grey80 = ui_grey80;

// Green

export const ui_success = '#098650';
/**
* @deprecated use ui_success instead
*/
export const green = ui_success;

// Red
export const ui_alert = '#C32B13';
/**
* @deprecated use ui_alert instead
*/
export const red = ui_alert;

// White
export const ui_white = '#FFFFFF';
/**
* @deprecated use ui_alert instead
*/
export const white = ui_white;

/** Colors v3 */
export const bombas_offblack = '#5A5A63';
export const bombas_offwhite = '#F8F7F7';
export const ui_primary = bombasBlue;
export const ui_accent = bombasSeafoam;

/**
* @deprecated use bombas_offblack instead
*/
export const bombasOffBlack = 'hsl(240, 5%, 37%)';
